import { Row, Typography, Col, Button, Space } from 'antd';
import { useHistory } from 'react-router-dom';

const NotFoundPage = () => {
  const history = useHistory();

  const handleLoginClick = () => {
    history.push('/login');
  };

  const handleHomeClick = () => {
    history.push('/app/dashboard');
  };

  return (
    <Row
      style={{ height: '100vh', width: '100%' }}
      justify="center"
      align="middle"
      gutter={24}
    >
      <Col style={{ borderLeft: '1px solid #F0F0F0', paddingLeft: '48px' }}>
        <Row>
          <Typography.Title>404</Typography.Title>
        </Row>
        <Row>
          <Typography.Paragraph>
            Desculpe, mas a página solicitada não existe, ou foi removida.
          </Typography.Paragraph>
        </Row>
        <Row>
          <Space>
            <Button type="primary" onClick={handleHomeClick}>
              Voltar para Home
            </Button>

            <Button onClick={handleLoginClick}>Ir para Login</Button>
          </Space>
        </Row>
      </Col>
    </Row>
  );
};

export default NotFoundPage;
